/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  ReportUrl,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ReportUrlFromJSON,
    ReportUrlToJSON,
} from '../models/index';

export interface GetClaimsSummaryReportRequest {
    d: string;
    h: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetClaimsSummaryReportUrlRequest {
    startDate: string;
    endDate: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetCouponExportReportRequest {
    d: string;
    h: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetCouponExportReportUrlRequest {
    startDate: string;
    endDate: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetSearchAnalyticsReportRequest {
    d: string;
    h: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetSearchAnalyticsReportUrlRequest {
    startDate: string;
    endDate: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class ReportsApi extends runtime.BaseAPI {

    /**
     * Return a report CSV stream for the parameters that go along with a token.
     */
    async getClaimsSummaryReportRaw(requestParameters: GetClaimsSummaryReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['d'] == null) {
            throw new runtime.RequiredError(
                'd',
                'Required parameter "d" was null or undefined when calling getClaimsSummaryReport().'
            );
        }

        if (requestParameters['h'] == null) {
            throw new runtime.RequiredError(
                'h',
                'Required parameter "h" was null or undefined when calling getClaimsSummaryReport().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getClaimsSummaryReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['d'] != null) {
            queryParameters['d'] = requestParameters['d'];
        }

        if (requestParameters['h'] != null) {
            queryParameters['h'] = requestParameters['h'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }


        let urlPath = `/v1/{customerId}/reports/claims-summary/report`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Return a report CSV stream for the parameters that go along with a token.
     */
    async getClaimsSummaryReport(requestParameters: GetClaimsSummaryReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getClaimsSummaryReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a report URL for the provided date range (inclusive).  This report URL will contain a cryptographic payload to allow fetching the report without authorization.  The URL will have a 1-hour time limit it is good for, after which you will need to get a new URL
     */
    async getClaimsSummaryReportUrlRaw(requestParameters: GetClaimsSummaryReportUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportUrl>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling getClaimsSummaryReportUrl().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling getClaimsSummaryReportUrl().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getClaimsSummaryReportUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:reports"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/reports/claims-summary/{startDate}/{endDate}`;
        urlPath = urlPath.replace(`{${"startDate"}}`, encodeURIComponent(String(requestParameters['startDate'])));
        urlPath = urlPath.replace(`{${"endDate"}}`, encodeURIComponent(String(requestParameters['endDate'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportUrlFromJSON(jsonValue));
    }

    /**
     * Gets a report URL for the provided date range (inclusive).  This report URL will contain a cryptographic payload to allow fetching the report without authorization.  The URL will have a 1-hour time limit it is good for, after which you will need to get a new URL
     */
    async getClaimsSummaryReportUrl(requestParameters: GetClaimsSummaryReportUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportUrl> {
        const response = await this.getClaimsSummaryReportUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return a coupon export CSV stream for the parameters that go along with a token.
     */
    async getCouponExportReportRaw(requestParameters: GetCouponExportReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['d'] == null) {
            throw new runtime.RequiredError(
                'd',
                'Required parameter "d" was null or undefined when calling getCouponExportReport().'
            );
        }

        if (requestParameters['h'] == null) {
            throw new runtime.RequiredError(
                'h',
                'Required parameter "h" was null or undefined when calling getCouponExportReport().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCouponExportReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['d'] != null) {
            queryParameters['d'] = requestParameters['d'];
        }

        if (requestParameters['h'] != null) {
            queryParameters['h'] = requestParameters['h'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }


        let urlPath = `/v1/{customerId}/reports/coupon-export/report`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Return a coupon export CSV stream for the parameters that go along with a token.
     */
    async getCouponExportReport(requestParameters: GetCouponExportReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getCouponExportReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a report URL for the daily coupon export snapshot on the provided date.  This is a point-in-time snapshot report, so pass the same date for startDate and endDate to download a single day\'s file. The URL contains a cryptographic payload to allow fetching the report without authorization and is good for 1 hour, after which a new URL is required.
     */
    async getCouponExportReportUrlRaw(requestParameters: GetCouponExportReportUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportUrl>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling getCouponExportReportUrl().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling getCouponExportReportUrl().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCouponExportReportUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:reports"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/reports/coupon-export/{startDate}/{endDate}`;
        urlPath = urlPath.replace(`{${"startDate"}}`, encodeURIComponent(String(requestParameters['startDate'])));
        urlPath = urlPath.replace(`{${"endDate"}}`, encodeURIComponent(String(requestParameters['endDate'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportUrlFromJSON(jsonValue));
    }

    /**
     * Gets a report URL for the daily coupon export snapshot on the provided date.  This is a point-in-time snapshot report, so pass the same date for startDate and endDate to download a single day\'s file. The URL contains a cryptographic payload to allow fetching the report without authorization and is good for 1 hour, after which a new URL is required.
     */
    async getCouponExportReportUrl(requestParameters: GetCouponExportReportUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportUrl> {
        const response = await this.getCouponExportReportUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return a report CSV stream for the parameters that go along with a token.
     */
    async getSearchAnalyticsReportRaw(requestParameters: GetSearchAnalyticsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['d'] == null) {
            throw new runtime.RequiredError(
                'd',
                'Required parameter "d" was null or undefined when calling getSearchAnalyticsReport().'
            );
        }

        if (requestParameters['h'] == null) {
            throw new runtime.RequiredError(
                'h',
                'Required parameter "h" was null or undefined when calling getSearchAnalyticsReport().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getSearchAnalyticsReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['d'] != null) {
            queryParameters['d'] = requestParameters['d'];
        }

        if (requestParameters['h'] != null) {
            queryParameters['h'] = requestParameters['h'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }


        let urlPath = `/v1/{customerId}/reports/search-analytics/report`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Return a report CSV stream for the parameters that go along with a token.
     */
    async getSearchAnalyticsReport(requestParameters: GetSearchAnalyticsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getSearchAnalyticsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a report URL for the provided date range (inclusive).  This report URL will contain a cryptographic payload to allow fetching the report without authorization.  The URL will have a 1-hour time limit it is good for, after which you will need to get a new URL
     */
    async getSearchAnalyticsReportUrlRaw(requestParameters: GetSearchAnalyticsReportUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportUrl>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling getSearchAnalyticsReportUrl().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling getSearchAnalyticsReportUrl().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getSearchAnalyticsReportUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:reports"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/reports/search-analytics/{startDate}/{endDate}`;
        urlPath = urlPath.replace(`{${"startDate"}}`, encodeURIComponent(String(requestParameters['startDate'])));
        urlPath = urlPath.replace(`{${"endDate"}}`, encodeURIComponent(String(requestParameters['endDate'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportUrlFromJSON(jsonValue));
    }

    /**
     * Gets a report URL for the provided date range (inclusive).  This report URL will contain a cryptographic payload to allow fetching the report without authorization.  The URL will have a 1-hour time limit it is good for, after which you will need to get a new URL
     */
    async getSearchAnalyticsReportUrl(requestParameters: GetSearchAnalyticsReportUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportUrl> {
        const response = await this.getSearchAnalyticsReportUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
